import { useSearchParams, Navigate } from 'react-router-dom';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { CreditCard } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { OverviewTab } from './accounting/OverviewTab';
import { PayrollTab } from './accounting/PayrollTab';
import { JournalEntriesTab } from './accounting/JournalEntriesTab';
import { ProjectPLTab } from './accounting/ProjectPLTab';
import { ReportsTab } from './accounting/ReportsTab';
import AccountingCalendarView from '@/components/AccountingCalendarView';
import AccountsPayableTab from '@/components/AccountsPayableTab';

export default function AccountingPage() {
  const { hasPerm, loading } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'overview';

  // Route guard: redirect users without view_accounting back to dashboard.
  if (loading) return null;
  if (!hasPerm('view_accounting')) return <Navigate to="/dashboard" replace />;

  return (
    <div className="space-y-6 animate-fade-in" data-testid="accounting-page">
      <div>
        <h1 className="text-[22px] font-medium tracking-tight">Accounting</h1>
      </div>

      <Tabs value={activeTab} onValueChange={v => setSearchParams({ tab: v })} className="space-y-4">
        <TabsList className="flex-wrap h-auto" data-testid="accounting-tabs">
          <TabsTrigger value="overview" data-testid="tab-overview">Overview</TabsTrigger>
          <TabsTrigger value="payroll" data-testid="tab-payroll">Payroll Pipeline</TabsTrigger>
          <TabsTrigger value="payable" data-testid="tab-accounts-payable" className="gap-1">
            <CreditCard className="h-3 w-3" /> Accounts Payable
          </TabsTrigger>
          <TabsTrigger value="journal" data-testid="tab-journal">Journal Entries</TabsTrigger>
          <TabsTrigger value="project-pl" data-testid="tab-project-pl">Project P&L</TabsTrigger>
          <TabsTrigger value="reports" data-testid="tab-reports">Reports</TabsTrigger>
          <TabsTrigger value="acct-calendar" data-testid="tab-acct-calendar">Calendar</TabsTrigger>
        </TabsList>

        <TabsContent value="overview"><OverviewTab /></TabsContent>
        <TabsContent value="payroll"><PayrollTab /></TabsContent>
        <TabsContent value="payable"><AccountsPayableTab /></TabsContent>
        <TabsContent value="journal"><JournalEntriesTab /></TabsContent>
        <TabsContent value="project-pl"><ProjectPLTab /></TabsContent>
        <TabsContent value="reports"><ReportsTab /></TabsContent>
        <TabsContent value="acct-calendar"><AccountingCalendarView /></TabsContent>
      </Tabs>
    </div>
  );
}
